import { render, staticRenderFns } from "./CVUploader.vue?vue&type=template&id=142b79a8&scoped=true&"
import script from "./CVUploader.vue?vue&type=script&lang=js&"
export * from "./CVUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142b79a8",
  null
  
)

export default component.exports